(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4-image-gallery"] && !Shopify.designMode) return;
  try {
    
// Optional JS can be added here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-gallery"] && !Shopify.designMode) return;
  try {
    
// Optional JS can be added here

  } catch(e) { console.error(e); }
})();
})();
